import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFax, faPhone } from '@fortawesome/pro-solid-svg-icons';
import { valueOrPlaceholder } from 'helpers/string_helpers';

export default class PhoneLink extends React.Component {
  static propTypes = {
    disabled: PropTypes.bool,
    fax: PropTypes.bool,
    phone: PropTypes.string,
    onClick: PropTypes.func
  };

  static defaultProps = {
    disabled: false,
    fax: false,
    placeholderOnBlank: true
  };

  clickable = () => !this.props.disabled && !this.props.fax && this.props.onClick;
  hasPhone = () => this.props.phone != null && this.props.phone !== '';

  render() {
    if (this.hasPhone() && this.clickable()) {
      return this.renderLink();
    } else {
      return this.renderPlainTextOrTelLink();
    }
  }

  renderLink() {
    return (
      <a
        className="phone-link"
        href="javascript:;"
        onClick={this.props.onClick}
      >
        <FontAwesomeIcon
          className="right-buffer-sm"
          icon={faPhone}
          name="link-icon"
          size="sm"
        />
        {this.props.phone}
      </a>
    );
  }

  renderTelLink(phone) {
    return <a href={`tel:${phone}`}>{phone}</a>;
  }

  renderPlainTextOrTelLink() {
    const { disabled, fax, phone } = this.props;
    const renderIcon = fax && !disabled;
    const renderLink = this.hasPhone() && !fax;
    const formattedPhone = valueOrPlaceholder(phone);

    return (
      <React.Fragment>
        {renderIcon && <FontAwesomeIcon className="right-buffer-sm" icon={faFax} name="link-icon" size="sm" />}
        {renderLink ? this.renderTelLink(formattedPhone) : formattedPhone}
      </React.Fragment>
    );
  }
}
